<template>
  <div v-if="isVisible" class="modal-overlay">
    <div class="modal-body">
      <div class="head-body">
        {{ title }}
      </div>
      <div class="input-content">
        <div class="input-body">
          <input type="text" placeholder="请输入名称" v-model="dirValue" />
        </div>
      </div>
      <div class="btns-body">
        <div class="btn clean" @click="close">取消</div>
        <div class="span"></div>
        <div class="btn success" @click="submit">确认</div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      editFile: {
        type: Object,
        default: {
          id: 0,
          name: ''
        }
      },
      title: {
        type: String,
        default: '新建文件夹'
      }
    },
    data() {
      // 这里存放数据
      return {
        dirValue: '',
        id: 0,
        isDir: 0,
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {
      editFile: {
        handler(newVal, oldVal) {
          // this.dirValue = newVal.name
          this.id = newVal.id
          this.isDir = newVal.isDir
        },
        deep: true
      }
    },
    // 方法集合
    methods: {
      close() {
        this.$emit('update:isVisible', false);
      },
      submit() {
        if (this.dirValue.trim() == '') {
          this.$toast('请输入文件名');
          return;
        }
        if (this.id == 0) {
          this.$emit('submitCreateDir', this.dirValue);
          this.dirValue = '';
          this.isDir = 0;
          this.id = 0;
          this.close();
        } else {
          this.$emit('submitRename', {id: this.id, name: this.dirValue, is_dir: this.isDir});
          this.dirValue = '';
          this.isDir = 0;
          this.id = 0;
          this.close();
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(68,68,68, .2);
    .modal-body {
      width: 452px;
      height: 180px;
      background-color: white;
      border-radius: 14px;
      box-shadow: -10px 4px 7px 4px rgba(68,68,68, .2);
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      .head-body {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        font-size: 16px;
        font-weight: bold;
      }
      .input-content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        .input-body {
          height: 50px;
          width: 100%;
          padding: 0 16px;
          background-color: rgba(250, 250, 250, 1);
          border-radius: 8px;
          input {
            width: 100%;
            height: 100%;
            background-color: rgba(250, 250, 250, 1);
            border-radius: 8px;
          }
        }
      }
      .btns-body {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 64px;
        .span {
          width: 12px;
        }
        .btn {
          flex: 1;
          height: 32px;
          background-color: rgba(0, 0, 0, 0.04);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          border-radius: 8px;
          font-weight: bold;
        }
        .btn:hover {
          cursor: pointer;
        }
        .success {
          background-color: rgba(74, 131, 255, 1);
          color: white;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/create_dir_dialog.vue